import PropTypes from 'prop-types';
import React from 'react';
import MentionOptionComponent from "../../../../editor-universal/common/mention-option-component/mention-option-component";
import BaseComponent from "../../../../base-component/base-component";

const propTypes = {
    mention: PropTypes.object,
    //more may be passed by mentions plugin
};

class MentionOptionViewComponent extends BaseComponent {

    constructor(props) {
        super(props);
    }

    render() {
        const { mention, children, className } = this.props;
        return <MentionOptionComponent className={className} viewType="view" mention={mention}>{children}</MentionOptionComponent>
    }
}

MentionOptionViewComponent.propTypes = propTypes;

module.exports = MentionOptionViewComponent;